import { ArrowCircleDown } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import React from 'react';

import { ProductRow } from './ProductRow';

const cellSx = {
  borderRadius: 2,
  px: 1.5,
  py: 1,
  backgroundColor: '#eeeeee',
  minWidth: 0,
};

export const UnitDetails = ({ unit, onSelectCell }) => {
  const products = unit.datas.length ? unit.datas : [unit];

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'stretch',
        gap: 1,
        px: 1.5,
        py: 1,
        borderBottom: '1px solid',
        borderColor: 'divider',
        opacity: unit.readOnly ? 0.7 : 1,
      }}
    >
      <Box
        onClick={onSelectCell ? () => onSelectCell(unit) : undefined}
        sx={{
          ...cellSx,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
        }}
      >
        <ArrowCircleDown />
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 1,
          width: '100%',
        }}
      >
        {products.map(item => (
          <ProductRow key={item.guid} item={item} />
        ))}
      </Box>

      {unit.rowName ? (
        <Box
          sx={{
            ...cellSx,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Typography variant="body2">{unit.rowName}</Typography>
        </Box>
      ) : null}
    </Box>
  );
};
